import React from "react"

import PropTypes from "prop-types"

import * as styles from "./checkbox-group.module.scss"

const CheckboxGroup = ({ children, label, htmlFor }) => (
  <div>
    <label className={styles.label} htmlFor={htmlFor}>
      {label}
    </label>
    <div className={styles.checkboxGroup}>{children}</div>
  </div>
)

export default CheckboxGroup

CheckboxGroup.propTypes = {
  children: PropTypes.node.isRequired,
  label: PropTypes.string,
  htmlFor: PropTypes.string,
}

CheckboxGroup.defaultProps = {
  label: "",
  htmlFor: "",
}
